var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h2',[_vm._v("Videos")]),_c('br'),(_vm.haveVideos)?_c('video-list',{attrs:{"videoList":_vm.videosList}}):_c('coming-soon',{staticClass:"coming-soon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }